class TableFormatModel {
  constructor(data, total) {
    this.content = Array.from(data);
    this.totalElements = total || Array.from(data).length;
  }
}

export default TableFormatModel;
